import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sheet", "backdrop"]

  connect() {
    this.boundEscape = this.handleEscape.bind(this)
  }

  toggle() {
    if (this.isOpen) { this.close() } else { this.open() }
  }

  open() {
    this.sheetTarget.hidden = false
    this.backdropTarget.hidden = false
    void this.sheetTarget.offsetWidth
    this.sheetTarget.dataset.open = ""
    this.backdropTarget.dataset.open = ""
    document.addEventListener("keydown", this.boundEscape)
    document.body.style.overflow = "hidden"
  }

  close() {
    delete this.sheetTarget.dataset.open
    delete this.backdropTarget.dataset.open
    document.removeEventListener("keydown", this.boundEscape)
    document.body.style.overflow = ""
    setTimeout(() => {
      this.sheetTarget.hidden = true
      this.backdropTarget.hidden = true
    }, 300)
  }

  handleEscape(event) {
    if (event.key === "Escape") this.close()
  }

  get isOpen() {
    return this.sheetTarget.dataset.open !== undefined
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundEscape)
  }
}
